import ReactModal from "react-modal";
import React, {Component} from "react";
import ReactTable from 'react-table';
import {
    icon,
    modal,
    modalOverlay,
    tableBase,
    TableExpander,
    TableLike,
    TableNonExpander
} from '../../../styles/Details';
import theme from "../../../styles/theme";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Flex, {FlexChild} from "../../../styles/Flex";
import {Tooltip} from 'react-tippy';
import {NoIcon, OkIcon} from "../../Icons";
import 'react-tippy/dist/tippy.css';
import {atLeastMediaWidth} from '../../../styles/mediaQueries'
import {Header} from "./Header";
import {ClipboardCopy} from "./Clipboard";
import {Status} from "../Status";
import {decorateUrl} from "./utils";

if (process.env.NODE_ENV !== 'test') {
    ReactModal.setAppElement('#root');
}

const ChangeLog = (props) => {
    return <ReactTable
        data={props.logEntries}
        columns={props.addMargin(
            Object
                .keys(props.logEntries[0])
                .map(k => {return {Header: k, accessor: k}}),
            props.level + 2,
            props.width
        )}
        collapseOnDataChange={false}
        defaultSorted={[{id: "date",}]}
        pageSize={props.logEntries.length}
        showPaginationBottom={false}
        sortable={true}
    />
};

const Tabular = (props) => {
    let key = 0; // suppress ugly React unique key prop warning with fake key
    const header = <header>
        {
            props.data.shift().map(x => <div key={key++} className="col">{x}</div>)
        }
    </header>;
    const lineBreak = <div key={key++} className="line-break"/>;
    const rows = props.data.map(row =>
        <div key={key++} className="row">
            {
                row.map(col => <div key={key++} className="col">{col}</div>)
            }
        </div>
    ).reduce((prev, curr) => [prev, lineBreak, curr]);
    return (
        <TableLike>
            <section>
                {header}
                {lineBreak}
                {rows}
            </section>
        </TableLike>
    );
};

const DataFormat = (props) => {
    const prep = (arr, type) => arr.concat(
        props.val[type]
            .map(x => x.grid+" ("+x.format.join(", ")+")")
            .reduce((prev, curr) => {
                    if (typeof prev === "string"){
                        prev += ","
                    } else {
                        prev[-1] += ",";
                    }
                    return [prev, curr];
                }
            )
    );
    let tabularRow1 = ["Originator: "];
    let tabularRow2 = ["DTN: "];
    tabularRow1 = prep(tabularRow1, "originator");
    tabularRow2 = prep(tabularRow2, "mg");
    return <Tabular data={[tabularRow1, tabularRow2]}/>;
};

const SpatialRange = props => {
  return <div>{props.description}</div>;
};

const LegalUsage = props => {
    let commonData = [
        ["License Link:", decorateUrl(props.licenseLink)],
        ["Notes:", decorateUrl(props.notes)]
    ];
    let tableData = [];
    [
        "broadcastLicenseCustomer", "broadcastLicenseMg",
        "internetLicenseCustomer", "internetLicenseCustomer",
        "rawDataDelivery", "resellByMg", "slaByOriginator"
    ].forEach(
        name => tableData.push([
            name + ":",
            props[name].active ? <OkIcon/> : <NoIcon/>,
            decorateUrl(props[name].notes)
        ])
    );
    return <div style={{marginLeft: (props.level + 1) * props.expanderCellWidth, padding: "5px"}}>
        <Tabular data={commonData}/>
        <Tabular data={tableData}/>
    </div>

};

export const DetailsOverlay = props => {
    if (!props.modalState.show) {
        return <div/>
    }

    let contentLabel;
    const detailType = props.modalType || 'PARAMETER';
    const metadata = props.modalState.metadata;
    switch (detailType.toUpperCase()) {
        case 'MODEL':
            contentLabel = "Model " + metadata.name;
            break;
        case 'GRID':
            contentLabel = "Grid for " + metadata.name;
            break;
        case 'ACCESS':
            contentLabel = "Access for " + metadata.name;
            break;
        default:
            contentLabel = "Parameter " + metadata.name;
    }

    return (
        <ReactModal
            isOpen={props.modalState.show}
            contentLabel={contentLabel}
            className={modal}
            overlayClassName={modalOverlay}
            onRequestClose={props.close}
        >
            <Flex
                direction={"row"}
                style={{marginBottom: "10px"}}
                justifyContent={"space-between"}
                flexWrapReverse
            >
                <Header
                    name={metadata.headerName}
                    originatorShortName={metadata.originatorShortName}
                    modelName={metadata.modelName}
                    freeText={metadata.freeText}
                />
                <Flex
                    direction={"row"}
                    justifyContent={"flex-end"}
                    grow={1}
                >
                    <ClipboardCopy data={props.modalState.data}/>
                    <Tooltip
                        title={"Close"}
                        arrow={true}
                        distance={0}
                        theme={"light"}
                    >
                        <FontAwesomeIcon
                            key={props.modalState.show}
                            icon={"times-circle"}
                            onClick={props.close}
                            className={icon}
                            size={"2x"}
                        />
                    </Tooltip>
                </Flex>
            </Flex>
            <Flex style={{overflow: "auto"}}>
                <FlexChild style={{flexGrow: 1}}>
                    <Details {...props.modalState}/>
                </FlexChild>
            </Flex>
        </ReactModal>
    )
};

class Details extends Component {
    constructor(props) {
        super(props);
        const allContent = Object.keys(props.data).map(key => {
            return {name: key, value: props.data[key]};
        });
        const filteredContent = allContent.filter(row => this.passesFilter(row.name));

        let level = 0;
        if (props.hasOwnProperty('level')) {
            level = props.level;
        }
        const nextLevel = level + 1;

        this.state = {
            originalData: props.data,
            data: filteredContent,
            rowState: {},
            level: level,
            nextLevel: nextLevel,
            nameColWidth: this.getAdaptableWidth(),
            width: 0,
            height: 0,
        };

        this.expanderCellWidth = 28;
        this.resizeTimer = null;
    }

    throttledUpdateDimensions = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.updateDimensions, 250);
    };

    updateDimensions = () => {
        const w = window;
        const d = document;
        const documentElement = d.documentElement;
        const body = d.getElementsByTagName('body')[0];
        const width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
        const height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

        this.setState({width: width, height: height, nameColWidth: this.getAdaptableWidth()});
    };

    updateRowState = () => {
        let newState = {rowState: {}};
        this.state.data.forEach(
            row => newState.rowState[row.name] = this.setRowState(this.state.originalData, row)
        );
        this.setState(newState);
    };

    componentWillMount = () => {
        this.updateDimensions();
        this.updateRowState();
    };

    componentDidMount = () => window.addEventListener("resize", this.throttledUpdateDimensions);

    componentWillUnmount = () => window.removeEventListener("resize", this.throttledUpdateDimensions);

    cloneObject = item => JSON.parse(JSON.stringify(item));

    isObject = item => typeof item === 'object' && item !== null;

    isNumeric = item => !isNaN(Number(item));

    isArray = item => item != null && item.constructor === Array;

    isEmptyArray = item => this.isArray(item) && item.length === 0;

    isArrayOfSingleElement = item => this.isArray(item) && item.length === 1;

    isArrayOfObjects = item => this.isArray(item) && item.every(subItem => this.isObject(subItem));

    isArrayOfScalars = item => this.isArray(item) && !this.isEmptyArray(item) && !this.isArrayOfObjects(item);

    hasSubElements = item => this.isObject(item) && !this.isArrayOfScalars(item) && !this.isEmptyArray(item);

    getExpander = row => {
        if (this.state.rowState[row.original.name].showExpander) {
            return (
                <TableExpander isExpanded={row.isExpanded}>
                    <FontAwesomeIcon icon={"caret-right"} size={"lg"}/>
                </TableExpander>
            );
        } else {
            return <TableNonExpander/>;
        }
    };

    getAdaptableWidth() {
        if (atLeastMediaWidth('xLarge')) {
            return 200;
        } else {
            return 100;
      }
    };

    formatValue(data, row) {
        const name = row.name;
        const value = row.value;

        switch (name) {
            case "status":
                return {
                    formattedVal:<Status {...data}/>,
                };
            case "changeLog":
                return {
                    formattedVal: <div>...</div>,
                    hasSubComponent: true,
                    subComponentData:
                        <ChangeLog
                            logEntries={value}
                            level={this.state.level}
                            width={this.expanderCellWidth}
                            addMargin={this.addMargin}
                        />,
                    showExpander: true
                };
            case "dataFormat":
                return {
                    formattedVal:
                        <DataFormat
                            val={value}
                        />
                };
            case "spatialRange":
                // This is the grid view
                if (Object.keys(value).length > 1) {
                    return null;
                }
                // This is the parameter/model view
                return {
                    formattedVal: <SpatialRange description={value.description}/>
                };
            case "legalUsage":
                return {
                    formattedVal: <div>...</div>,
                    hasSubComponent: true,
                    subComponentData: <LegalUsage
                        level={this.state.level}
                        expanderCellWidth={this.expanderCellWidth}
                        {...value}
                    />,
                    showExpander: true
                };
            default:
                return null;

        }
    }

    setRowState = (data, row) => {
        const val = row.value;
        const name = row.name;
        let fVal = null;
        let formattedVal = null;
        let subComponentData = null;
        let hasSubComponent = false;
        let showExpander = false;

        if (val === null || val === undefined) {
            formattedVal =  <div>&mdash;</div>
        } else if (this.isEmptyArray(val)) {
            formattedVal =  <div>&mdash;</div>
        }  else if (fVal = this.formatValue(data, row)) {
            formattedVal = fVal.formattedVal || formattedVal;
            subComponentData = fVal.subComponentData || subComponentData;
            hasSubComponent = fVal.hasSubComponent || hasSubComponent;
            showExpander = fVal.showExpander || showExpander;
        } else if (this.isArrayOfScalars(val)) {
            formattedVal =  <div>
                {val
                    .map(x => decorateUrl(x))
                    .reduce((prev, curr) => {
                        // if this is an object (a link returned from decorateUrl()
                        // we want to show this in dedicated lines,
                        // otherwise just comma-delimited
                        if (this.isObject(curr)) {
                            return [prev, <br/>, curr];
                        } else {
                            return [prev, ", ", curr];
                        }
                    })
                }
            </div>
        } else if (this.isArrayOfObjects(val)) {
            formattedVal = <div>...</div>;
            subComponentData = val;
            hasSubComponent = true;
            showExpander = true;
        } else if (this.hasSubElements(val)) {
            formattedVal = <div>...</div>;
            subComponentData = val;
            hasSubComponent = true;
            showExpander = true;
        } else if (typeof val === "boolean") {
            if (val) {
                formattedVal = <OkIcon/>;
            } else {
                formattedVal = <NoIcon/>;
            }
        } else {
            formattedVal = <div>{decorateUrl(val)}</div>;
        }

        return {
            name: name,
            value: formattedVal,
            subComponentData: subComponentData,
            hasSubComponent: hasSubComponent,
            showExpander: showExpander
        };
    };


    getRowName = row => {
        if (this.isNumeric(row.original.name)) {
            return <div/>;
        } else {
            return <div>{row.original.name}</div>;
        }
    };

    getSubComponent = row => {
        const name = row.original.name;
        const state = this.state.rowState[name];
        if (state.hasSubComponent) {
            if (React.isValidElement(state.subComponentData)) {
                return state.subComponentData;
            }
            let newProps = this.cloneObject(this.props);
            newProps.data = state.subComponentData;
            newProps.level = this.state.nextLevel;
            return <Details { ...newProps}/>;
        } else {
            return null;
        }
    };

    passesFilter = item => !item.startsWith('_');

    addMargin = (columns, level, width) => {
        let calculatedWidth = width * level - 1;
        if (level > 0) {
            columns.unshift(
                {
                    Header: "",
                    width: calculatedWidth - level ,
                    minWidth: calculatedWidth - level,
                    maxWidth: calculatedWidth - level,
                    Cell: () => <div/>,
                }
            )
        }
        return columns;
    };

    getTableClasses = () => `-striped -highlight ${tableBase}`;

    render() {
        const { data } = this.state;
        return (
            <ReactTable
                data={data}
                columns={this.addMargin(
                    [
                        {
                            Header: "",
                            expander: true,
                            Expander: this.getExpander,
                            width: this.expanderCellWidth,
                            minWidth: this.expanderCellWidth,
                            maxWidth: this.expanderCellWidth,
                            style: {overflow: "hidden"}
                        },
                        {
                            Header: this.state.level === 0 ? "Name" : "",
                            accessor: "name",
                            width: this.state.nameColWidth,
                            Cell: this.getRowName,
                        },
                        {
                            Header: this.state.level === 0 ? "Value" : "",
                            accessor: "value",
                            style: {'whiteSpace': 'unset'},
                            Cell: (row) => this.state.rowState[row.original.name].value,
                        }
                    ],
                    this.state.level,
                    this.expanderCellWidth
                )}
                className={this.getTableClasses()}
                collapseOnDataChange={false}
                defaultSorted={[{id: "name",}]}
                pageSize={data.filter(row => this.passesFilter(row.name)).length}
                showPaginationBottom={false}
                sortable={false}
                style={{
                    fontFamily: theme.typography.fontFamily,
                    fontSize: "12px",
                    whiteSpace: "normal",
                }}
                SubComponent={this.getSubComponent}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/results/details/Details.js